/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

var Toolbar = __webpack_require__(843);
var Preview = __webpack_require__(844);
var Administration = __webpack_require__(845);
var $ = __webpack_require__(3);

var mobilepreview = __webpack_require__(1211);

$(document).ready(function() {
    if (window.diy && window.diy.context && !window.diy.context.isPublicView) {
        // Used in mobilepreview php view
        diy.core.namespace('diy.editor').mobilepreview = mobilepreview;

        var toolbar = new Toolbar();

        mobilepreview.setToolbar(toolbar);

        toolbar.Administration = new Administration(toolbar);
        toolbar.Preview = new Preview(toolbar);
    }
});


/***/ },

/***/ 3:
/***/ function(module, exports) {

module.exports = jQuery;

/***/ },

/***/ 21:
/***/ function(module, exports) {

module.exports = Modernizr;

/***/ },

/***/ 492:
/***/ function(module, exports) {

/**
 * A collection of utilities to help with page related issues
 * like spacing for toolbars, autoscroll, keepScroll, etc
 */
Object.defineProperty(exports, "__esModule", { value: true });
function getWebViewEl() {
    return document.querySelector('.diyw');
}
exports.getWebViewEl = getWebViewEl;
var currentTopSpace = 0;
function makeTopSpace(height, keepVisualPosition) {
    if (keepVisualPosition === void 0) { keepVisualPosition = false; }
    var webView = getWebViewEl();
    if (!webView) {
        return;
    }
    var translateRule = "translateY(" + height + "px)";
    var topBefore = webView.getBoundingClientRect().top;
    webView.style.transform = translateRule;
    webView.style.webkitTransform = translateRule;
    // in happy case when background is top aligned, we can make the magic to
    // remain visually aligned, best effort ...
    if (parseInt(getComputedStyle(document.body).backgroundPositionY, 10) === 0) {
        document.body.style.backgroundPositionY = height + 'px';
    }
    var topAfter = webView.getBoundingClientRect().top;
    currentTopSpace = height;
    if (keepVisualPosition) {
        // compensate the scroll so that things would stay visually in the same place
        var scrollDelta = topAfter - topBefore;
        window.scrollBy(0, scrollDelta);
        var topAfterScroll = webView.getBoundingClientRect().top;
        if (topAfterScroll > topBefore) {
            // then we probably didn't have enough scrollHeight to compensate the scroll
            var scrollCompensation = topAfterScroll - topBefore;
            document.body.style.paddingBottom = scrollCompensation + 'px';
            window.scrollBy(0, scrollCompensation);
        }
    }
}
exports.makeTopSpace = makeTopSpace;
function getTopSpace() {
    return currentTopSpace;
}
exports.getTopSpace = getTopSpace;
function clearTopSpace(keepVisualPosition) {
    if (keepVisualPosition === void 0) { keepVisualPosition = false; }
    makeTopSpace(0, keepVisualPosition);
    var webView = getWebViewEl();
    var translateRule = '';
    webView.style.transform = translateRule;
    webView.style.webkitTransform = translateRule;
    document.body.style.backgroundPositionY = '';
    document.body.style.paddingBottom = '';
}
exports.clearTopSpace = clearTopSpace;


/***/ },

/***/ 843:
/***/ function(module, exports, __webpack_require__) {

/**
 * Toolbar class - showed horizontally on top of the whole editing mode of the Sitebuilder
 *
 * @depends jquery.js
 * @depends extendClass.js
 * events: hide / show
 * plugins : mobile preview, undo redo, logout ...
 *
 */
/*global Klazz, diy, jQuery */
var $ = __webpack_require__(3);
var Modernizr = __webpack_require__(21);
var PageUtil = __webpack_require__(492);

var Toolbar, positionToolbar;

var previousPosition;

var TOOLBAR_HEIGHT = 38; // it's a known visual height, cannot be calculated because it contains the shaddow

positionToolbar = function () {
    $('#diyToolbar').css({
        position: 'fixed',
        left: '0',
        right: '0',
        top: '0'
    });

    $('#diyToolbar').trigger('diy-editor-toolbar-repositioned');
};

var scrollRefreshHandler = function() {
    var windowScroll = $(window).scrollTop(),
        isTouchEnabled = diy.context.type === 'editor' ?
            diy.editor.uiPreference.isPointerModeTouch() : Modernizr.touch;

    if (isTouchEnabled) {
        if(windowScroll < 0 || windowScroll >= document.documentElement.scrollHeight - window.innerHeight) {
            return;
        }
    }

    positionToolbar();
};

Toolbar = Klazz.extend({
    activated: false,
    options: {},

    isActive: function () {
        return this.activated === true;
    },

    initialize: function(options) {
        if (typeof options !== 'undefined' && options.length) {
            this.options = $.extend(true, {}, this.options, options); // note: we break object reference
        }

        // position the toolbar on the first load //
        this.draw();

        positionToolbar();
        this.activated = true;
    },

    draw: function() {
        var toolbarElement;

        toolbarElement = $(
            '<div class="diye"><div id="diyToolbar" class="diyEditorTopSpacer diyEditorTopFixedSpacer">' +
                '<div class="panels" >' +
                    '<div class="panel leftPanel"></div>' +
                    '<div class="panel rightPanel"></div>' +
                    '<div class="panel centerPanel"></div>' +
                '</div>' +
            '</div></div>'
        );
        $('body').prepend(toolbarElement);

        this.element = $('#diyToolbar');
        this.addContextClass();
        PageUtil.makeTopSpace(TOOLBAR_HEIGHT);

        // remove any leftover controls from the footer //
        $('#contentfooter .loggedin').remove();
    },

    addContextClass: function () {
        var className = '';

        switch (diy.context.type) {
            case 'web':
                className = 'diy-toolbar-web';
                break;
            case 'editor':
                className = 'diy-toolbar-editor';
                break;
            case 'mobilepreview':
                className = 'diy-toolbar-mobilePreview';
                break;
            default:
                throw new Error('Invalid context type');
        }

        this.element.addClass(className);
    },

    pushToPanel: function(panel, content, prepend) {
        var panelEl;

        if (!this.isActive()) {
            return false;
        }

        panelEl = $('#diyToolbar .' + panel + 'Panel');

        if (!prepend) {
            return $(content).appendTo(panelEl);
        } else {
            return $(content).prependTo(panelEl);
        }
    },

    getPanel: function(panel)
    {
        if (!this.isActive()) {
            return false;
        }
        return $('#diyToolbar .' + panel + 'Panel');
    },

    getElement: function() {
        return this.element;
    }

});

module.exports = Toolbar;


/***/ },

/***/ 844:
/***/ function(module, exports, __webpack_require__) {

/**
 * Toolbar - Preview pane of the toolbar
 *  Contains the web/mobile preview functions.
 *
 * @depends jquery.js
 * @depends extendClass.js
 *
 */
/*global Klazz, diy, jimdoData, jQuery, systemurl, script_basisID, stagingMode */
var $ = __webpack_require__(3);

var Preview, initEditView, initWebView, initMobilePreview,
    initEditViewInMobilePreview, initWebViewInMobilePreview;

initEditView = function (targetElement) {
    var pageId;

    // try to get the page id from several places - this is needed until all page caches expire //
    pageId = $('body').attr('data-pageid');
    if (!pageId) {
        pageId = jimdoData.pageId;
    }
    if (pageId) {
        targetElement.attr('href', systemurl + 'app/' + script_basisID + '/' + pageId + '/');
    } else {
        targetElement.attr('href', systemurl + 'app/' + script_basisID + '/');
    }
};
initWebView = function (targetElement) {
    targetElement.attr('href', systemurl + 'app/default/index/gotoviewmode/websiteId/' +
        script_basisID + '/pageId/' + $('body').attr('data-pageid'));
};
initMobilePreview = function(targetElement) {
    targetElement.attr('href', systemurl + 'app/default/index/gotomobileview/websiteId/' +
        script_basisID + '/pageId/' + $('body').attr('data-pageid')
    );
};
initEditViewInMobilePreview = function (targetElement) {
    targetElement.attr('href', window.backLinkUrl);
};
initWebViewInMobilePreview = function(targetElement) {
    targetElement.attr('href', window.previewPageUrl);
};

Preview = Klazz.extend({
    contextType: '', /* possible values: editor, web */
    toolbar: null,
    options: {
        classSelected : 'selected'
    },
    messages: {
        viewLabel : '',
        backToEditingLabel: '',
        tooltipWebView: '',
        tooltipMobileView: ''
    },
    element: null,
    setup: function(){
        this.contextType = diy.context.type;
        this.messages = $.extend(true, {}, this.messages, jimdoData.messages.toolbar); // note: we break object reference
        this.options = $.extend(true, {}, this.options); // note: we break object reference
        this.messages.backToEditingLabel = jimdoData.messages.back;
    },
    initialize: function(toolbar) {
        this.toolbar = toolbar;
        this.setup();
        this.draw();
    },
    draw: function(){
        var elementHtml,
            self = this,
            isTouchDevice = Modernizr.touch;

        // build buttons HTML //
        elementHtml = '<div id="previewContainer" >';

        elementHtml += '<a class="label viewLabel" style="display: none;">' + this.messages.viewLabel + '</a> ';
        elementHtml += '<a class="label backLabel" style="display: none;">' + this.messages.backToEditingLabel + '</a> ';

        elementHtml += '<a class="webView ' + (this.contextType === 'web' ? this.options.classSelected : '') + '"><div class="icon" title="'+ this.messages.tooltipWebView +'"></div></a> ';

        /* if mobile preview is enabled, add the button to the toolbar */
        elementHtml += '<div class="mobile-preview-button-container">';
            elementHtml += '<div class="mobile-preview-button-container">' +
                '<a class="mobileView"><div class="icon" title="'+ this.messages.tooltipMobileView +'"></div></a> ';
        elementHtml += '</div></div>';

        if (this.contextType === 'editor') {
            elementHtml += '<div class="spacer"><div class="icon"></div></div>';
        }

        elementHtml += '</div>';

        this.element = this.toolbar.pushToPanel('left', elementHtml);

        if (!isTouchDevice) {
            if (this.contextType === 'editor') {
                this.element.find('.viewLabel').show();
            } else if (this.contextType === 'web') {
                this.element.find('.backLabel').show();
            }
        }

        if (this.contextType === 'editor') {
            this.showMobilePreviewStartButton();
        }

        if (this.contextType === 'editor') {
            initWebView(this.element.find('.webView'));
            initMobilePreview(this.element.find('.mobileView'));
        } else if (this.contextType === 'web') {
            initEditView(this.element.find('.webView'));
            initEditView(this.element.find('.backLabel'));
        } else if (this.contextType === 'mobilepreview') {
            initEditViewInMobilePreview(this.element.find('.backLabel'));
            initWebViewInMobilePreview(this.element.find('.webView'));
            initEditViewInMobilePreview(this.element.find('.mobileView'));
        }

        if (this.contextType === 'web') {
            this.element.find('.mobileView').click(function() {
                var currentState = self.isMobilePreviewStateActive();
                if (currentState) {
                    diy.editor.mobilepreview.close();
                } else {
                    diy.editor.mobilepreview.open();
                }
                self.setMobilePreviewStateActive(!currentState);
            });
        }
    },
    showMobilePreviewStartButton: function() {
        this.element.find('.mobile-preview-button-container').show();
    },
    setMobilePreviewStateActive: function(b) {
        var $previewContainer = $('#previewContainer'),
            hideElList,
            isTouchDevice = Modernizr.touch;
        $previewContainer.find('.mobileView')[b ? 'addClass' : 'removeClass']('selected');

        // HACK: list of elemeents that are not displayed in mobile preview
        // Each element should say if it's displayable or not, but for now
        // we keep this list here
        hideElList = [
            '.undo-redo-widget',
            '.maintenanceModeContainer',
            '#previewContainer .spacer:first',
            '.helpSearchContainer',
            '.helpContainer + .spacer',
            '.helpContainer',
            '#administrationContainer + .spacer'
        ];

        if ('mobilepreview' === this.contextType) {
            $(hideElList.join(', '))[b ? 'hide' : 'show']();
            if (!isTouchDevice) {
                if (b) {
                    $previewContainer.find('.backLabel').show().one('click.mobilepreviewback', function() {
                        diy.editor.mobilepreview.close();
                    });
                    $previewContainer.find('.viewLabel').hide();
                } else {
                    $previewContainer.find('.backLabel').hide().unbind('click.mobilepreviewback');
                    $previewContainer.find('.viewLabel').show();
                }
            }
        }
    },
    isMobilePreviewStateActive: function() {
        return $('#previewContainer .mobileView').hasClass('selected');
    },
    backAction: function() {
        window.location.href = this.element.find('.backLabel').attr('href');
    }
});

module.exports = Preview;


/***/ },

/***/ 845:
/***/ function(module, exports, __webpack_require__) {

/**
 * Toolbar
 *  Contains just the logout button for now.
 *
 * @depends jquery.js
 * @depends extendClass.js
 *
 */
/*global Klazz, diy, jimdoData, jQuery, systemurl */
var $ = __webpack_require__(3);

var Administration = Klazz.extend({
    contextType: '', /* possible values: editor, web */
    toolbar: null,
    options: {
        classSelected: 'selected'
    },
    messages: {
        logoutLabel: jimdoData.messages.logout,
        tooltipLogout: ''
    },
    element: null,
    setup: function() {
        this.contextType = diy.context.type;
        this.messages = $.extend(true, {}, this.messages, jimdoData.messages.toolbar); // note: we break object reference
        this.options = $.extend(true, {}, this.options); // note: we break object reference
    },
    initialize: function(toolbar) {
        this.toolbar = toolbar;
        this.setup();
        this.draw();
    },
    draw: function(){
        var self = this,
            elementHtml = '',
            isTouchEnabled = diy.context.type === 'editor' ? diy.editor.uiPreference.isPointerModeTouch() :
                Modernizr.touch,
            elementInnerText = isTouchEnabled ?
                '<span class="icon" />'
                :
                this.messages.logoutLabel;

        elementHtml += '<div id="administrationContainer">';
        elementHtml += '<div class="label logout" title="'+
            this.messages.tooltipLogout +
            '">' +
            elementInnerText +
            '</div>';
        elementHtml += '</div>';

        this.element = this.toolbar.pushToPanel('right', elementHtml);

        // activate the logout button //
        this.element.find('.logout').click(function () {
            switch (self.contextType) {
                case 'editor':
                    window.logout();
                    break;
                case 'web':
                    window.location = systemurl + 'app/cms/logout.php';
                    break;

                case 'mobilepreview':
                    window.location = systemurl + 'app/cms/logout.php?no_referer=1';
                    break;
            }
        });
    }
 });

module.exports = Administration;


/***/ },

/***/ 1211:
/***/ function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);
var Modernizr = __webpack_require__(21);

;(function() {
    "use strict";

    var options, /* options object */
        messages = {}, /* translations object */
        template, /* the HTML template that will be used */
        $mobile, /* the main mobile jQuery element */
        $overlay, /* the overlay jQuery element */
        $iframe, /* the iframe jQuery element in which the mobile preview is loaded */
        $oldLayouts, /* the promo for chosing a new layout jQuery element */
        $forceDesktop, /* the message shown when mobile view looks like desktop */
        $body, /* jQuery reference to the page body */
        toolbar; /* toolbar object */

    var setToolbar = function(_toolbar) {
        toolbar = _toolbar;
    };

    /**
     * initializes the user interface for the mobile preview frame
     */
    var initUi = function() {
        /* add the mobile preview button to the toolbar */
        if (toolbar &&  toolbar.Preview) {
            toolbar.Preview.showMobilePreviewStartButton();
        }

        /* add messages from jimdoData */
        $.extend(true, messages, jimdoData.messages.mobilepreview);

        template = '' +
            '<div class="mp-mobile-container">' +
            '   <div class="mp-mobile-frame">' +
            '       <div class="mp-close"></div>' +
            '       <div class="mp-iframe-wrapper"><iframe frameborder="0"></iframe></div>' +
            '       <div class="mp-force-desktop"><p>' + messages.forcedesktop.text + '</p></div>' +
            '       <div class="mp-old-layouts">' +
            '           <div class="mp-bubble">' +
            '               <p>' + messages.promolayouts.text + '</p>' +
            '               <button style="display: none;">' + messages.promolayouts.editor.button + '</button>' +
            '               <svg viewBox = "0 0 100 100" version = "1.1" width="34" height="34">' +
            '                   <path d="M 2 0 L 2 100 L 100 0" stroke="#0fabfc" stroke-width="2" fill="#ffffff"/>' +
            '               </svg>' +
            '           </div>' +
            '       </div>' +
            '   </div>' +
            '</div>';

        // append the template
        $mobile = $(template).appendTo($body).wrap('<div class="diye"></div>');
        // append the overlay
        $overlay = $('<div id="mp-overlay"></div>')
            .appendTo($body)
            .wrap('<div class="diye"></div>');
        // get iframe reference
        $iframe = $mobile.find('.mp-mobile-frame iframe');
        // get old layouts message
        $oldLayouts = $mobile.find('.mp-old-layouts');
        // get force desktop message
        $forceDesktop = $mobile.find('.mp-force-desktop');

        /* iPad seems to need a few extra rules to display it correctly */
        if (Modernizr.touch) {
            $mobile.find('.mp-iframe-wrapper').addClass('mp-iframe-wrapper-ios');
        }

        // when clicking the "Select layout" button, Layout selector
        // should open with "Flexible Layouts" filter selected
        if (options.renderMode === 'editor') {
            $oldLayouts.find('button')
                .show()
                .button()
                .bind('click', function() {
                    close();
                    /*trigger click on SA Layouts entry*/
                    diy.editor.siteadmin.api.triggerMenuItem('cc-sa-item-layoutselector', {openTo: ''});
                    /*mark history change - to be able to switch back to the settings window*/
                    diy.editor.siteadmin.api.setSidebarActiveItem('cc-sa-item-layoutselector');
            });
        }

        // clicking the phone's home button should close it
        $mobile.find('.mp-close').bind('click', function() {
            close();
        });
    };

    /**
     * position the overlay so it covers all sitebuilder. take care of the
     * various toolbars such as testdrive, the undo redo toolbar and so on
     */
    var positionOverlay = function() {
        var top = $('#diyToolbar').offset().top + $('#diyToolbar').outerHeight();
        $overlay.css('top', top - $(window).scrollTop());
    };

    /**
     * close the mobile preview
     */
    var close = function() {
        if (options.renderMode == 'mobilepreview') {
            toolbar.Preview.backAction();
            return;
        }

        /* allow main document scrolling again */
        $(document).unbind('.mppreventscroll');

        /* set back scrolling to the main window when mobile preview is closed */
        $body.removeClass('mp-no-scroll');

        /* hide the mobile preview frame */
        $mobile.animate({
            bottom: -600
        }, 500, function() {
            $overlay.hide();
            /* set about:blank to free the iframe */
            $iframe.attr('src', 'about:blank');
        });

        /* update the undo redo toolbar state */
        toolbar.Preview.setMobilePreviewStateActive(false);
    };

    /**
     * open the mobile preview
     */
    var open = function() {

        if (options.renderMode == 'mobilepreview') {
            // we need to manually update the toolbar state, because this wasn't
            // necessarily open from the preview button
            toolbar.Preview.setMobilePreviewStateActive(true);
        }

        /* prevent ipad main document scrolling, as it interferes with the iframe scrolling */
        $(document).bind('touchmove.mppreventscroll touchdown.mppreventscroll', function(e) {
            e.preventDefault();
        });

        /* remove the scrolling on the main window when mobile preview is opened */
        $body.addClass('mp-no-scroll');
        $overlay.show();
        positionOverlay();

        /* show the mobile frame */
        $mobile.css({
            bottom: -600,
            marginBottom: '-282px'
        }).show().animate({
            bottom: '50%'
        }, 500);

        $oldLayouts.toggle(!options.responsive);
        $forceDesktop.toggle(!options.activateMobileOptimization);
        $iframe.toggle(options.responsive && options.activateMobileOptimization);

        /* if it has a responsive layout, open the web view */
        if (options.responsive && options.activateMobileOptimization) {
            /* set the mobile preview iframe source */
            var mobileSrc = "";
            if (options.renderMode === 'editor') {
                mobileSrc = $('.webView').attr('href');
            } else if (options.renderMode === 'web') {
                mobileSrc =  webserverProtocol + webServerName + location.pathname;
            } else if (options.renderMode === 'mobilepreview') {
                mobileSrc = options.previewPageUrl;
            }
            mobileSrc += '?mobilepreview=1&publicview=1';
            $iframe.attr('src', mobileSrc);
        }

        /* require two succesive clicks (not dblclick!) to close */
        $overlay.one('click', function() {
            $overlay.one('click', close);
        });
    };

    var initInnerBehaviour = function() {
        /* add mobilepreview class on the body
        reason is to enable some media queries that hide the apps
        only if in mobile preview, to simulate the live mobile device */
        $body.addClass('mobilepreview');

        /* append publicview and mobilepreview to all links */
        $('a[href]').bind('click', function() {
            var url = $(this).attr('href');
            /* only for local links (relative & absolute on the same domain) */
            if ('/' === url.charAt(0) || 0 === url.indexOf(webserverProtocol + webServerName)) {
                url += '?publicview=1&mobilepreview=1';
                $(this).attr('href', url);
            }
        });

        /* hide the "Logout" and "Edit page" in the footer */
        $('.loggedin').hide();

        /* block any actions in the modules and in the page */
        $('button, input[type="button"]').unbind('click');
        $('form').unbind('submit').bind('submit', function(){return false;});

        /* can't make the top link work properly due to the custom scrollbar */
        $('a.diyfeTopLink').hide();

        /* initialize the scrolling */
        var jspApi = $body.jScrollPane({
            mouseWheelSpeed: 40,
            horizontalGutter: 0,
            verticalGutter: 0
        }).data('jsp');

        /* the content height may change as some modules will load additional content */
        setInterval(function() {
            jspApi.reinitialise();
        }, 1000);
    };

    var init = function(_options) {
        options = $.extend(_options, {});

        $body = $('body');

        /*
        depending if this code gets executed in the mobile frame or outside of it
        it does two different things:
            - if it's executed inside the mobile preview frame:
                - add the mobile scrollbars
                - make sure that mobile preview links are being propagated further
                - disable all the modules in the page (so they can't be used)
            - if it's executed outside the mobile preview frame:
                - just create the mobile frame and run the web view in it
                - when running inside, it will do what is described at the first step
         */
        if (options['isMobilePreviewView']) {
            /* web view additions when invoked */
            initInnerBehaviour();
        } else {
            /* create the mobile preview elements */
            initUi();
        }
    };

    /* export public methods */
    return $.extend(this, {
        init: init,
        open: open,
        close: close,
        setToolbar: setToolbar
    });

}).call(exports);


/***/ }

/******/ });


/** WEBPACK FOOTER **
 ** toolbarMobilePreview.bundle.js
 **/